/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const PreloaderIcon = /*#__PURE__*/ createSvgIcon(
  'PreloaderIcon',
  {
    ltr: {
      small: ({ id }) => (
        <>
          <g clipPath={`url(#${id}_0)`}>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5.221 1.107a7.62 7.62 0 015.763.062l.008.004a7.57 7.57 0 013.93 9.818l-.003.007a7.5 7.5 0 01-9.836 3.932.5.5 0 11.393-.92A6.5 6.5 0 0014 10.605a6.57 6.57 0 00-3.407-8.516A6.62 6.62 0 001.98 5.494a6.83 6.83 0 00.004 5.031.5.5 0 11-.93.37 7.83 7.83 0 010-5.78l.004-.009.004-.01a7.62 7.62 0 014.158-3.99z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h16v16H0z" />
            </clipPath>
          </defs>
        </>
      ),
      medium: ({ id }) => (
        <>
          <g clipPath={`url(#${id}_0)`}>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M6.481 1.253a9.66 9.66 0 017.293.076l.008.003a9.58 9.58 0 014.98 12.44l-.004.008a9.55 9.55 0 01-12.452 4.98.5.5 0 11.388-.92 8.55 8.55 0 0011.146-4.456 8.58 8.58 0 00-4.458-11.135A8.66 8.66 0 002.131 6.695a8.93 8.93 0 00.003 6.62.5.5 0 01-.928.37 9.93 9.93 0 010-7.37l.004-.01.004-.009A9.66 9.66 0 016.48 1.253z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h20v20H0z" />
            </clipPath>
          </defs>
        </>
      ),
      large: ({ id }) => (
        <>
          <g clipPath={`url(#${id}_0)`}>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7.74 1.332a11.7 11.7 0 018.833.087l.01.004a11.6 11.6 0 016.019 15.07l-.003.005A11.5 11.5 0 017.534 22.52a.5.5 0 01.392-.92 10.5 10.5 0 0013.754-5.495 10.6 10.6 0 00-5.498-13.766A10.7 10.7 0 002.281 7.844a10.98 10.98 0 00.003 8.13.5.5 0 01-.928.371 11.98 11.98 0 010-8.88l.003-.01.004-.009A11.7 11.7 0 017.74 1.332z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h24v24H0z" />
            </clipPath>
          </defs>
        </>
      ),
    },
  },
  false
);

export default PreloaderIcon;
